module.exports = __webpack_public_path__ + "static/prevent-downtime-bcf6d9c5709fd1c4fbc507b64cf2edbc.svg";